"use client";

import { Handshake, HeartHandshake, Users } from "lucide-react";
import {
  FadeIn,
  HomeEyebrow,
  HomeHeading,
  HomeLead,
  HomeSection,
} from "~/components/siteglue/home/section-shell";

const PILLARS = [
  {
    icon: Users,
    title: "Built for your team",
    body: "AI employees cover the front door so your people can focus on high-value work.",
  },
  {
    icon: HeartHandshake,
    title: "Designed with empathy",
    body: "Conversations stay natural, on-brand, and ready for a human when judgment matters.",
  },
  {
    icon: Handshake,
    title: "Partnership, not replacement",
    body: "SiteGlue exists to connect people with AI—never to push humans out of the loop.",
  },
] as const;

export function SiteGlueHomeBuiltForHumans() {
  return (
    <HomeSection id="ai-built-for-humans" tone="white">
      <FadeIn>
        <HomeEyebrow>Agents Connecting People.</HomeEyebrow>
        <HomeHeading>Set up an agent that works with your people.</HomeHeading>
        <HomeLead>
          The agent answers, captures or schedules appointments when connected, and routes the
          conversation while your team stays in control.
        </HomeLead>
      </FadeIn>

      <div className="mt-14 grid gap-8 sm:grid-cols-3">
        {PILLARS.map((pillar, i) => (
          <FadeIn key={pillar.title} delay={0.08 * (i + 1)}>
            <div className="h-full">
              <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-[#4f81bd]/10 text-[#4f81bd]">
                <pillar.icon className="h-5 w-5" strokeWidth={1.75} aria-hidden />
              </div>
              <h3 className="mt-5 text-lg font-semibold text-slate-900">{pillar.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-600">{pillar.body}</p>
            </div>
          </FadeIn>
        ))}
      </div>
    </HomeSection>
  );
}
